import { withStyles, WithStyles } from "@mui/styles";
import typographyStyle from "assets/jss/mui-extras/typographyStyle";
import * as React from "react";

interface IProps {
    content: string | JSX.Element | JSX.Element[],
    author?: React.ReactNode
}

type Props = IProps & WithStyles<typeof typographyStyle>;

const MuiQuote: React.FC<Props> = (props) => {
    const { classes, content, author } = props;

    if (content == null)
        return null;

    return (
        <blockquote className={classes.defaultFontStyle + " " + classes.quote}>
            {typeof (content) == "string" ? <p className={classes.quoteText}>{content}</p> : <>{content}</>}
            {author && <small className={classes.quoteAuthor}>{author}</small>}
        </blockquote>
    );
}

export default withStyles(typographyStyle)(MuiQuote);